@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title}}" [(visible)]="display" showEffect="fade" [modal]="true" appendTo="body" [style]="{'width':'500px'}">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="container-md">
      <!-- NAME -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="fineReason-reason" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'tableManagement.fineReason.reason' | translate}}
                </label>
          <input type="text" id="fineReason-reason" class="form-control custom-input" style="width: 100%;" [(ngModel)]="entity.reason">
        </div>
      </div>
      <!-- ENABLED -->
      <div class="row mt-3 mb-3">
        <div class="col-12">
          <label for="fineReason-enabled" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'control-panel.poi-categories.poiEnabled' | translate }}
                </label>
          <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
            type="checkbox" [(ngModel)]="active" [disabled]="true">
        </div>
      </div>
    </div>
    <!-- #endregion BODY -->
  </div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="save()" i18n>
                        {{'general.save' | translate}}
                    </button>
            </div>
          }
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="save()" i18n>
                        {{'general.create' | translate}}
                    </button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="changeStatus(!entity.disabled)" i18n>
                        {{'general.changeStatus' | translate}}
                    </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}